import { Controller } from '@hotwired/stimulus'
import { application } from './application'

let asyncControllerLoaded = false

export default class extends Controller {
  connect () {
    if (!asyncControllerLoaded) {
      asyncControllerLoaded = true
      import('./bar_chart_controller_async').then((controller) => {
        application.load([{ identifier: 'bar-chart', controllerConstructor: controller.default }])
      }, () => { })
    }
  }
}
